import Vue from "vue";
import VueRouter from "vue-router";

import worldEcharts from "@/views/worldEcharts.vue";
import three from "@/views/three.vue";

import login from "../views/login/login.vue"; //登录
import home from "@/views/home/home.vue"; //首页
import index from "@/views/index/index.vue"; //公共页
import intelligentControl from "@/views/intelligentControl/intelligentControl.vue"; //养殖灌溉
import fourEmotions from "@/views/fourEmotions/fourEmotions.vue"; //四情
import trEmotions from "@/views/fourEmotions/trEmotions.vue"; //土壤墒情

import cropModel from '@/views/cropModel/cropModel.vue' //作物模型
import farming from '@/views/farming/farming.vue' //农事

import intelligentAgriculturalMachinery from '@/views/intelligentAgriculturalMachinery/intelligentAgriculturalMachinery.vue' //智能农机
import fertilizationAnalysis from '@/views/intelligentControl/fertilizationAnalysis.vue' //施肥分析
import waterAffairs from '@/views/waterAffairs/waterAffairs.vue' //水务

import mapNew from "@/views/mapNew.vue"; //首页
Vue.use(VueRouter);

const routes = [{
		path: "/login",
		name: "login",
		component: login,
		meta: {
			keepAlive: true,
		},
	},
	{
			path: "/mapNew",
			name: "mapNew",
			component: mapNew,
			meta: {
				keepAlive: true,
			},
		},
	{
		path: "/",
		name: "index",
		component: index,
		meta: {
			keepAlive: true,
		},
		children: [{
				path: "/",
				component: home,
				meta: {
					keepAlive: true,
				},
			},
			{
				path: "/intelligentControl",
				component: intelligentControl,
				meta: {
					keepAlive: true,
				},
			},
			{
				path: "/fourEmotions",
				name: "fourEmotions",
				component: fourEmotions,
				meta: {
					keepAlive: true,
				},
			},
			{
				path: "/trEmotions",
				name: "trEmotions",
				component: trEmotions,
				meta: {
					keepAlive: true,
				},
			},
			{
				path: "/cropModel",
				name: "cropModel",
				component: cropModel,
				meta: {
					keepAlive: true,
				},
			},
			{
				path: "/farming",
				name: "farming",
				component: farming,
				meta: {
					keepAlive: true,
				}
			},
			{
				path: "/fertilizationAnalysis",
				name: "fertilizationAnalysis",
				component: fertilizationAnalysis,
				meta: {
					keepAlive: true,
				},
			}, {
				path: "/waterAffairs",
				name: "waterAffairs",
				component: waterAffairs,
				meta: {
					keepAlive: true,
				},
			},
			{
				path: "/intelligentAgriculturalMachinery",
				name: "intelligentAgriculturalMachinery",
				component: intelligentAgriculturalMachinery,
				meta: {
					keepAlive: true,
				},
			},

		],
	},
];

const router = new VueRouter({
	mode: "hash",
	base: process.env.BASE_URL,
	routes,
});

export default router;